<form  [formGroup]="form" (ngSubmit)="login()">

    <div class="container min-vh-dynamic d-flex flex-column">

      <div class="text-center mt-4">
          <h1 class="big-title" [title]="'Version ' + config.VERSION">Dates Saugrenue</h1>
      </div>

      <div class="grow d-flex align-items-center">
          <div class="w-100 px-3">

              <div class="mb-3">
                  <input type="text" formControlName="username" class="form-control form-control-lg" placeholder="Nom">
              </div>

              <div class="mb-3">
                  <input type="password" formControlName="password" class="form-control form-control-lg" placeholder="Mot de passe">
              </div>            

          </div>
      </div>

      <div class="mb-4 px-3">
          <button type="submit" class="btn btn-primary btn-lg w-100">
              Se connecter
          </button>
      </div>

  </div>

</form>